import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';
// import Header from '../../features/Header';
import Footer from '../../features/Footer';

const CheckoutComplete = React.lazy(() =>
  import('../../views/CheckoutComplete')
);

const params = [];
const CheckoutCompleteRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout footer={<Footer />}>
        <CheckoutComplete />
      </Layout>
    </RouteParameter>
  );
};

CheckoutCompleteRoute.propTypes = {};

CheckoutCompleteRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(CheckoutCompleteRoute);
